@charset "UTF-8";

/* src/app/forms/wizard-configuracao/d-para-view/d-para-view.component.scss */
.cid-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  font-weight: 300;
  text-align: center;
}
properties-value-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.full-width {
  width: 100%;
}
.data-save-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
mat-table {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  flex: 1 1 0px;
}
table {
  width: 100%;
  table-layout: fixed;
}
.mat-mdc-row,
.mat-mdc-header-row {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}
.mat-mdc-cell,
.mat-mdc-header-cell {
  flex-basis: 0;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-mdc-cell {
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 100%;
}
.mat-mdc-header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.grid-input {
  height: 100%;
  width: 100%;
}
.more-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 90%;
  padding-right: 10px;
  padding-left: 10px;
}
.more-options-horizontal {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.space4 {
  padding-right: 10px;
}
.step {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
  gap: 6px;
}
.more-options {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
mat-stepper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.query-text {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
mat-divider {
  padding-bottom: 6px;
}
.inactive {
  background-color: red;
  color: white;
  border-radius: 16px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 90%;
}
.active {
  background-color: green;
  color: white;
  border-radius: 16px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 90%;
}
/*# sourceMappingURL=d-para-view.component.css.map */
